import React, { useEffect, useRef, useState } from "react";
import ESignStyles from "./DDPIEsign.module.scss";
import image from "../../../Components/assets/Images/bankupdateesignimage.svg";
import { LoadingButton } from "@mui/lab";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import esignImage from "../../../Components/assets/Images/new esign_page-0001 - Copy - Copy.jpg";
import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PDFViewerIframe from "../../../Components/PDFIframe/PDFWithIframe";
import { useNavigate } from "react-router-dom";

import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import backicon from "../../../Components/assets/Images/back.svg";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import keyboardicon from "../../../Components/assets/Images/esignicongrey.svg";
import PDFViewerIframeEsign from "../../../Components/PDFIframe/PDFIframeEsign";
import {
  CreateEsignPDFDDPIAPICall,
  EsignRequestDDPIAPICall,
  GetStatusDDPIAPICall,
} from "../DDPIAPICalls";
import { REDIRECTURL } from "../../../shared/constants";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "10px 0px 0px 5px",
};

function DDPIEsign() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [showModal, setshowModal] = useState(false);
  const [continueOption, setcontinueOption] = useState(true);
  const [pdf, setpdf] = useState("");
  const timerRef = useRef<any>(null);
  const [startloading, setstartloading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [continueEsignLoading, setcontinueEsignLoading] = useState(false);
  const requestid: any = sessionStorage.getItem("requestid");

  useEffect(() => {
    window.scrollTo(0, 0);
    StatusDetails();
  }, []);

  const FillEsignPdf = (req: any) => {
    let obj: any = {
      req_id: req || "",
    };
    // setloading(true);
    CreateEsignPDFDDPIAPICall(obj)
      .then((response: any) => {
        // console.log("response", response);
        setpdf(response.data.data.url);
        setPdfUrl(response.data.data.url);

        // setloading(false);
      })
      .catch((error: any) => {
        // setloading(false);
      });
  };

  useEffect(() => {
    if (startloading) {
      setloading(true);
      if (pdfUrl) {
        setshowModal(true);
        setloading(false);
        setstartloading(false);
      }
    }
  }, [pdfUrl, startloading]);

  const StatusDetails = () => {
    GetStatusDDPIAPICall()
      .then((response: any) => {
        console.log("status", response.data.data);
        sessionStorage.setItem("requestid", response.data.data.request_id);
        FillEsignPdf(response.data.data.request_id);
        if (response.data.data.err_msg) {
          setRejectMessage(response.data.data.err_msg);
        }
        if (
          response.data.data.stage === "APPROVED" ||
          response.data.data.stage === "COMPLETED"
        ) {
          navigate("/ddpi/completed");
        }
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (childWindowRef) {
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef]);

  const handleEsignNow = () => {
    if (pdfUrl) {
      setshowModal(true);
      setloading(false);
    } else {
      handleEsignNow();
    }
  };

  function checkChild() {
    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      setloading(false);

      StatusDetails();
    }
  }

  const openHtmlPage = (htmlString: string) => {
    const blob = new Blob([htmlString], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    window.location.href = url;
  };

  const handleOpenClick = () => {
    setloading(true);
    let digilink: string = "";

    let obj: any = {
      request_id: requestid,
      callback_url: `${REDIRECTURL}ddpi/esignResponse`,
    };
    EsignRequestDDPIAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        var url = responseData.data.esp_html;
        var trimmedUrl = url.replace(":444", "");
        digilink = url;
        // window.location.href = digilink;
        // var trimmedUrl = url.replace(":444", "");
        // digilink = url;
        openHtmlPage(digilink);
        // setTimeout(() => {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700",
        //   );
        //   setchildWindowRef(childWindow);
        // });
      })
      .catch((error: any) => {
        setcontinueEsignLoading(false);
        setloading(false);
        setErrorMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  };
  const handleOpenModal = () => {
    // setshowModal(true);
  };
  const handlePreviewClose = () => {
    setshowModal(false);
    setloading(false);
  };
  const handlePreviewClick = () => {
    setshowModal(true);
  };
  const handleContinue = () => {
    navigate("/ddpi/completed");
  };
  return (
    <div className={ESignStyles.mainWrapperTop}>
      <SnackBar message={ErrorMessage} />
      <ErrorSnackBar message={rejectMessage} />

      <div className={ESignStyles.wrapper}>
        {showModal && (
          <div
            className={ESignStyles.back}
            onClick={() => {
              if (showModal) {
                setshowModal(false);
              }
            }}
          >
            <img src={backicon} />{" "}
            <span className={ESignStyles.backText}>Back</span>
          </div>
        )}
        {showModal ? (
          <p className={ESignStyles.almostThereText}>Esign Preview</p>
        ) : (
          <div className={ESignStyles.step}>
            <img src={keyboardicon} /> Step 2 of 2
          </div>
        )}
        {showModal ? (
          ""
        ) : (
          <div className={ESignStyles.titleSection}>
            <p className={ESignStyles.almostThereText}>Almost There!</p>

            <p className={ESignStyles.title}>
              {" "}
              Digitally sign your application
            </p>
          </div>
        )}
        {!showModal ? (
          <div className={ESignStyles.container}>
            <div className={ESignStyles.leftcontainer}>
              <div>
                <div className={ESignStyles.textdiv}>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Click on
                    the E-Sign Button Below..
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter Your
                    Aadhaar Number.
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter the
                    OTP sent to your registered mobile number.
                  </p>
                </div>
                <div>
                  <>
                    <div className={ESignStyles.buttonStyles}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {continueOption ? (
                          <LoadingButton
                            type="submit"
                            variant="contained"
                            onClick={() => {
                              setstartloading(true);
                            }}
                            loading={loading}
                            id="aadharOpenLinkButton"
                            className={ESignStyles.esignButton}
                            sx={{ width: "187px", height: "50px" }}
                          >
                            Esign Now
                          </LoadingButton>
                        ) : (
                          <>
                            <div className={ESignStyles.sectionButton}>
                              <LoadingButton
                                className={ESignStyles.continue}
                                type="submit"
                                variant="contained"
                                sx={{ width: "187px", height: "50px" }}
                                onClick={handleContinue}
                                loading={loading}
                                id="aadharOpenLinkButton"
                              >
                                Continue
                              </LoadingButton>
                              <Button
                                className={ESignStyles.esignPreview}
                                type="submit"
                                variant="outlined"
                                sx={{
                                  color: "rgba(18, 183, 106, 1)",
                                  borderRadius: "20px",
                                }}
                                onClick={handlePreviewClick}
                                id="aadharOpenLinkButton"
                              >
                                View E-sign Document
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={ESignStyles.modalContainer}>
            <div className={ESignStyles.pdfMobilePreview}>
              <img
                src={esignImage}
                style={{
                  width: "95%",
                  height: "100%",
                  objectFit: "inherit",
                  // filter: "brightness(80%)",
                  border: "5px solid #525659",
                  marginBottom: "20px",
                }}
              />

              {/* <a
              href={pdfUrl}
              download="Esign-PDF-document"
              target="_blank"
              rel="noreferrer"
              className={ESignStyles.previewdownlaodesign}
            >
              <Button
                variant="contained"
                sx={{
                  background: "#1976d2",
                  "&:hover": { background: "#1976d2" },
                }}
              >
                View Esign Document
              </Button>
            </a> */}
            </div>
            <div className={ESignStyles.pdfDesktopPreview}>
              <PDFViewerIframeEsign urldata={pdfUrl} />
            </div>
            <Stack marginTop={"20px"} direction={"row"}>
              <LoadingButton
                loading={continueEsignLoading}
                variant="contained"
                sx={{
                  width: { xs: "150px", sm: "187px" },
                  margin: "auto",
                  height: "50px",
                }}
                onClick={handleOpenClick}
              >
                Continue
              </LoadingButton>
              <a
                href={pdfUrl}
                download="Esign-PDF-document"
                target="_blank"
                rel="noreferrer"
                className={ESignStyles.previewdownlaodesign}
              >
                <Button
                  variant="outlined"
                  sx={{
                    color: "#1F2937",
                    height: "50px",
                  }}
                >
                  View Esign PDF
                </Button>
              </a>
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
}

export default DDPIEsign;
